import { Injectable } from '@angular/core';
import { ApiBase } from '@apis/cas/ApiBase';
import { EnumType } from '@apis/cas/generated';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EnumTypeEndpoints extends ApiBase {
  public getEnumTypes(): Observable<EnumType[]> {
    return this.get<EnumType[]>(`/game/${this.gameId}/schema/enum-types`);
  }

  public getEnumType(enumTypeId: string): Observable<EnumType> {
    return this.get<EnumType>(`/game/${this.gameId}/schema/enum-types/${enumTypeId}`);
  }

  public createEnumType(enumType: EnumType, force = false): Observable<EnumType> {
    return this.post<EnumType>(`/game/${this.gameId}/schema/enum-types`, enumType, {
      params: force ? { force: 'true' } : undefined,
    });
  }

  public updateEnumType(updateEnumType: EnumType, force = false): Observable<EnumType> {
    return this.put<EnumType>(`/game/${this.gameId}/schema/enum-types/${updateEnumType.typeId}`, updateEnumType, {
      params: force ? { force: 'true' } : undefined,
    });
  }

  public deleteEnumType(enumTypeId: string, force = false): Observable<void> {
    return this.delete<void>(`/game/${this.gameId}/schema/enum-types/${enumTypeId}`, {
      params: force ? { force: 'true' } : undefined,
    });
  }
}
